import { render, staticRenderFns } from "./diff_discussion_row.vue.js?vue&type=template&id=63ec1de2&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diff_discussion_row.vue?vue&type=template&id=63ec1de2&vue3"
import script from "./diff_discussion_row.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diff_discussion_row.vue?vue&type=script&lang=js&vue3"
export * from "./diff_discussion_row.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diff_discussion_row.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports